import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class SiteReferenceService {
    public activeDeployments: any;
    public missionsSummary: any;
    public platformNames = ['dl', 'otn200', 'otn201', 'fundy', 'scotia', 'dal556', 'bond', 'we10', 'we04']; // TODO: Should not be hardcoded
    public backupKmlsUrl = 'https://gliders.oceantrack.org/ge/'; // all kmls
    public kmlsUrl = '/gliders/api/kml/'; // only active kmls
    public cfStandandardNamesUrl = 'https://cfconventions.org/Data/cf-standard-names/57/build/cf-standard-name-table.html';

    constructor() {
        const siteRef = window['SiteReference'];
        if (siteRef) {
            this.activeDeployments = window['SiteReference'].activeDeployments;
            this.missionsSummary = window['SiteReference'].missionsSummary;
        } else {
            console.error('window has no "SiteReference" property');
        }
    }
}
